// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"style_sponsors__372-X","title":"style_title__2_aIu","images":"style_images__31PkP","logo":"style_logo__3zzaM","blurb":"style_blurb__2Uyzh"};